import React from 'react';
import { toast } from 'react-toastify';

import { Form, Formik } from 'formik';
import type IPagination from 'interfaces/IPagination';
import { dateFormat } from 'v2/formatters/date';
import clearEmptyValues from 'v2/helpers/clearEmptyValues';
import type { Webhook, WebhookHistoryFilter as IWebhookHistoryFilter, WebhookHistory } from 'v2/interfaces/webhook2';
import webhookService from 'v2/services/webhook2';

import WebhookHistoricContext from './context';
import { FilterWebhookHistory } from './FilterWebhookHistory';
import { ListWebhookHistory } from './ListWebhookHistory';

type Props = {
  webhook: Webhook;
};

const today = dateFormat(new Date());

const initialFilter: IWebhookHistoryFilter = {
  date: [today, today],
  events: [],
  status: []
};

export const History = ({ webhook }: Props) => {
  const { _id: id, type, product_id } = webhook;

  const [webhookHistory, setWebhookHistory] = React.useState<WebhookHistory[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPagination, setCurrentPagination] = React.useState<IPagination>();
  const [filter, setFilter] = React.useState<Partial<IWebhookHistoryFilter>>();

  const getList = async (currentId: string, filter?: Partial<IWebhookHistoryFilter>, pg?: IPagination) => {
    try {
      setLoading(true);
      const { data, pagination } = await webhookService.historyList(currentId, filter, pg);
      setWebhookHistory(data);
      setLoading(false);
      setCurrentPagination(pagination);
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar histórico');
      setLoading(false);
    }
  };

  const updateList = async () => {
    setLoading(true);

    try {
      const { data, pagination } = await webhookService.historyList(id, filter, currentPagination);
      setWebhookHistory(data);
      setLoading(false);
      setCurrentPagination(pagination);
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar histórico');
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getList(id, initialFilter);
  }, [id]);

  const onSubmit = (values: IWebhookHistoryFilter) => {
    const filters = clearEmptyValues(values);
    setFilter(filters);
    getList(id, filters);
  };

  const changePagination = (pg: IPagination) => {
    getList(id, filter, pg);
  };

  const defaultValues: IWebhookHistoryFilter = { ...initialFilter, ...{ product_id: [] } };

  return (
    <WebhookHistoricContext.Provider
      value={{
        webhook,
        listWebhookHistory: webhookHistory,
        updateList,
        pagination: currentPagination,
        setPagination: changePagination,
        loading,
        product_id,
        type,
        id
      }}
    >
      <Formik initialValues={defaultValues} onSubmit={onSubmit}>
        <Form className='flex flex-col gap-4'>
          <div className='rounded-(--uizz-antd-border-radius-lg) bg-(--uizz-antd-color-fill-tertiary) p-4'>
            <FilterWebhookHistory />
          </div>
          <ListWebhookHistory />
        </Form>
      </Formik>
    </WebhookHistoricContext.Provider>
  );
};
